import { useWorkspaceMembersContext } from '~/providers/WorkspaceMembersProvider';

export const useFetchMembers = () => {
  return useWorkspaceMembersContext();
};
